



































































import Vue from 'vue'
import {mapState} from 'vuex'
import CrossCutRoot from './components/CrossCutRoot.vue'
import CatchmentTable from './components/CatchmentTable.vue'
import CreateCampaign from './components/CreateCampaign.vue'
import InfoTray from './components/InfoTray.vue'
import * as types from './store/types'
import * as actions from './store/actions'
import mapboxgl from 'mapbox-gl'

  

export default Vue.extend({
  name: 'App',

  components: {
    CrossCutRoot,
    CreateCampaign,
    InfoTray
  },

  data () {
    return {
      drawer: false,
      items: [],
      showCreateCampaign: false,

      
    }
  },

  computed: mapState({
    user: (state: any) => (state.user as types.Schema$User),
    loggedIn: (state: any, getters: any) => getters.loggedIn,
    showData: (state: any) => (state.showData),
  }),

  methods: {
    onHideDataWindow() {
      this.$store.commit(actions.TOGGLE_DATA_WINDOW)
    },

    onCreateCampaign() {
      this.showCreateCampaign = true

    }
  }
});
